import React, { Component } from 'react';



import Core from './../../Core/Core'
import ErrorManager from '../../Core/ErrorManager';

class Relations extends Component
{
    constructor(props)
    {
        super(props);

        this.edit = this.edit.bind(this);
        this.delete = this.delete.bind(this);
    }


    edit(id)
    {
        window.location.href = "/relation/edit/"+id
    }

    delete(id)
    {
        if(!window.confirm("Etes-vous sûr de vouloir supprimer cet élément ?"))
            return;
        Core.Instance.Request(Core.Address+"Relation/"+id, null, "DELETE").then((json)=> {
            ErrorManager.Instance.Info("L'élément a bien été supprimé.");
            window.location.reload();
        });
        
    }

    render()
    {
        let index = 0;
        let relations = this.props.relations == null ? [] : 
        this.props.relations.map((e) => {
            let date = e.date != null ? (new Date(e.date*1000)) : null;
            if(date != null)
                date = date.getDate().toString().padStart(2, "0")+"/"+(date.getMonth()+1).toString().padStart(2, "0")+"/"+date.getFullYear();
            return (
                <tr key={ e.id }>
                    <td>{ e.nature ? e.nature : '/' }</td>
                    <td>{ date ? date : '/'}</td>
                    <td>{ e.conseilor ? e.conseilor : '/'}</td>
                    <td>{ e.canal ? e.canal : '/'}</td>
                    <td>{ e.interest ? e.interest : '/' }</td>
                    <td>{ e.under_interest ? e.under_interest : '/' }</td>
                    <td>{ e.progress ? e.progress : '/' }</td>
                    <td>{ e.shortname ? e.shortname : '/' }</td>
                    <td>{ e.comment ? e.comment : '/' }</td>
                    <td>{ e.date_last_update ? e.date_last_update : '/' }</td>
                    {
                        this.props.editing == true && 
                        <td className="text-right">
                            <span className='fas fa-edit' onClick={ (ev) => { ev.preventDefault();this.props.loadRelation(e.id) }}/>
                            <span className='far fa-trash-alt ml-2' onClick={ (ev) => { ev.preventDefault();this.delete(e.id) } }/>
                        </td>
                    }
                </tr>
            );
        });
        
        return (
            <div>
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th>Nature</th>
                            <th>Date création</th>
                            <th>Conseiller</th>
                            <th>Canal</th>
                            <th>Type d'intérêt</th>
                            <th>Sous-type d'intérêt</th>
                            <th>Avancement</th>
                            <th>Nom Affaire</th>
                            <th>Commentaire</th>
                            <th>Date dernière modif.</th>
                            {
                                this.props.editing == true &&
                                <th></th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        { relations }
                    </tbody>
                </table>
            </div>
        );
    }
}

export default Relations;



// WEBPACK FOOTER //
// ./src/Components/Relation/Relations.js